<template>
    <div class="alpha-page">

      <section class="logo">
        <img src="@/assets/images/Logo_V2_Alpha.svg" alt="" class="nav-logo">
      </section>

      <section class="alpha-title">
        <h1>Join The Waitlist</h1>
      </section>

      <section class="alpha-paragraph">
        <p>Be the first to try our new features. <br>
          Join the alpha waitlist for early access <br>
          Get the new interface, RSS, file conversions, and more. <br><br>
          Sign up for <a class="s-text-premium" href="https://www.seedr.cc/premium">Premium</a> now to get priority.</p>
      </section>

      <section class="alpha-signup-comp">
        <SignUpForm formType="alpha"/>
      </section>
    </div>
</template>

<script>

import SignUpForm from '@/components/SignUpForm.vue'

export default {
  name: 'SignUp',
  components: {
    SignUpForm
  }
}
</script>
